module.exports = __webpack_public_path__ + "img/mam-mt4logo.095963aa.png";